import type { Solution, SolutionLinkResponse } from "@/model/solution";
import { ServerApiAccess } from "@/server-api-access";
import { useDomainStore } from "@/store/domain-store";
import { getSolutionUrl } from "./solution-url";
import type { AppLinkItem } from "./types";

export type { AppLinkItem } from "./types";

/** ソリューション一覧を返す */
export function getSolutionItems(domainId: string): AppLinkItem[] {
  const domainStore = useDomainStore();
  const solutions = (domainStore.getSolutions(domainId) || []) as Solution[];
  const directApps = (domainStore.getDirectApps(domainId) || []) as Solution[];
  const links = [...directApps, ...solutions].map((app) => {
    return {
      url: getSolutionUrl(domainId, app),
      iconUrl: app.icon_url,
      name: app.name.ja,
    };
  });

  // directを追加
  links.push({
    url: getSolutionUrl(domainId),
    iconUrl: "/img/icon/icon_talk_2.svg",
    name: "トーク",
  });

  return links;
}

export async function fetchSolutionLinks(
  domainId: string,
): Promise<SolutionLinkResponse | undefined | number> {
  const access = new ServerApiAccess();
  const result = await access.listApps(domainId);
  if (result && typeof result === "object") {
    // PhotoView を削除
    result.solutions = (result.solutions || []).filter(
      (app) => app.name.ja !== "PhotoView",
    );

    // 掲示板 を削除
    result.direct_apps = (result.direct_apps || []).filter(
      (app) => app.unique_key !== "forum",
    );
  }

  return result;
}
